export type RegisterRequest = {
	name: string;
	surname: string;
	email: string;
	phone_number: string;
	password: string;
	affiliation: string;
};

export type LoginResponse = {
	/** Absent when requiresTotp is true — finish login via verifyTotpLogin(). */
	accessToken?: string;
	role: string;
	requiresTotp?: boolean;
	challengeToken?: string;
};

/** 2FA is opt-in: the account either holds a factor or it does not. */
export type TwoFactorStatus = {
	enabled: boolean;
	/** A device change was started but the new device has not verified yet. */
	pendingReenrolment: boolean;
};

export type TwoFactorSetup = {
	secret: string;
	otpauthUrl: string;
};

export enum UserType {
	Admin = "ADMIN",
	Agent = "AGENT",
	Operator = "OPERATOR",
	OperatorSupport = "OPERATOR_SUPPORT",
	OperatorSupportDev = "OPERATOR_SUPPORT_DEV",
}

export const ROLE_LABELS: Record<string, string> = {
	[UserType.Admin]: "Admin",
	[UserType.Agent]: "Agent",
	[UserType.Operator]: "Operator",
	[UserType.OperatorSupport]: "Support",
	[UserType.OperatorSupportDev]: "Support Dev",
};

export type AccountProfile = {
	id: string;
	username: string;
	role: string;
	/** True when this session came from an admin's /login-as. */
	impersonated: boolean;
	/** Only operators and agents can hold a TOTP factor. */
	twoFactorSupported: boolean;
	twoFactorEnabled: boolean;
};

export type ChangePasswordRequest = {
	currentPassword: string;
	newPassword: string;
	confirmPassword?: string;
	/** Required when the account has 2FA enabled. */
	totpCode?: string;
};

export type ChangePasswordResponse = {
	success: boolean;
	reloginRequired: boolean;
};

export type ForgotPasswordRequest = {
	email: string;
};

export type ResetPasswordRequest = {
	token: string;
	new_password: string;
};
